import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  PagedResultDto_SandboxResponseDto,
  SandboxService,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetSwitchSandboxList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  //   tableFilterInfo: RolePublishFilterParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_SandboxResponseDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  //   const { companyName, roleName } = tableFilterInfo;

  const switchSandboxList = useQuery(
    ['getSwitchSandboxList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        SandboxService.getApiIdentityApiSandbox(filter, sorting, skipCount, maxResultCount)
      );
    }
  );

  return switchSandboxList;
};

export default useGetSwitchSandboxList;
